import { CertificateHistoryModel, DOCUMENT_STATUS } from 'api/documents/documents.model';
import Button from 'components/Buttons';
import useDownloadDocumentMutation from 'hooks/useDownloadDocumentMutation';

import { ReactComponent as DownloadIcon } from '../../../../../assets/download.svg';
import * as Styled from './DocumentDetails.styles';

const DocumentDetails = (document: CertificateHistoryModel) => {
  const { mutate: downloadDocument, isLoading: isDownloadDocumentLoading } =
    useDownloadDocumentMutation();

  const handleDownloadDocument = () =>
    downloadDocument({
      title: document.title,
      blockchainAddress: document.documentBlockchainAddress,
    });

  return (
    <Styled.CardRow>
      {`${document.title}.pdf`}
      <Button
        type="text"
        size="large"
        shape="circle"
        loading={
          [DOCUMENT_STATUS.PREPARED_TO_SIGN, DOCUMENT_STATUS.UPLOADING].includes(document.status) ||
          isDownloadDocumentLoading
        }
        icon={<DownloadIcon />}
        onClick={handleDownloadDocument}
      />
    </Styled.CardRow>
  );
};

export default DocumentDetails;
